import React from "react";

interface NotificationStateDisplayProps {
  variant: "empty" | "error";
  title: string;
  message: string;
  // Smaller icon for the header bell popup; full-size for the All Notifications page.
  compact?: boolean;
  className?: string;
}

// Shared icon+title+subtitle state — used by both the header bell popup and
// the All Notifications page so a failed fetch and a genuinely empty list
// read the same way on both surfaces. "empty" and "error" only differ in icon
// and copy, both supplied by the caller (already translated).
const NotificationStateDisplay: React.FC<NotificationStateDisplayProps> = ({
  variant,
  title,
  message,
  compact = false,
  className = "",
}) => {
  const icon = variant === "error" ? "/Icons/ThumbsDown.svg" : "/Icons/NoNotifications.svg";

  return (
    <div
      className={`notification-state-display notification-state-display--${variant}${
        compact ? " notification-state-display--compact" : ""
      } ${className}`.trim()}
      role={variant === "error" ? "alert" : undefined}
    >
      <img src={icon} alt="" aria-hidden className="notification-state-display__icon" />
      <strong className="notification-state-display__title">{title}</strong>
      <p className="notification-state-display__message">{message}</p>
    </div>
  );
};

export default NotificationStateDisplay;
